import { Image, Box, Link } from '@chakra-ui/react';
import React from 'react';
import CreatedByEmperia from '../../assets/images/created by emperia.png';
import CreatedByEmperiaAR from '../../assets/images/created by emperia ar.png';
import { Sound } from '../../Icons/Sound';
import { SoundDisabled } from '../../Icons/SoundDisabled';
import { OverlayProps } from '../../interfaces/components';
import { ToEng } from '../../Icons/ToEng';
import { ToArabic } from '../../Icons/ToArabic';
import { Info } from '../../Icons/Info';
import { Share } from '../../Icons/Share';
import { Up } from '../../Icons/Up';
import { Down } from '../../Icons/Down';

const Overlay = ({
  audioActive,
  activeScene,
  activeLocale,
  toggleInstructions,
  toggleAudio,
  setLocale,
  openSpread,
  setActiveScene,
}: OverlayProps) => {
  return (
    <Box className="layout">
      {/* Right Top Floating Buttons */}
      <Box
        position="fixed"
        height={['210px', '210px', '230px', '230px', '230px']}
        top={['15px', '20px', '25px']}
        right={['15px', '20px', '25px']}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        zIndex={6}
      >
        <Info
          marginLeft="auto"
          boxSize={[9, 9, 10, 10]}
          cursor="pointer"
          borderRadius="100%"
          fill="#FDC506"
          _hover={{
            fill: '#F9DD7D',
          }}
          transition="0.5s"
          onClick={() => toggleInstructions()}
        />
        {audioActive ? (
          <Sound
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={toggleAudio}
          />
        ) : (
          <Box
            bg="#FDC506"
            aria-label="Disable Music"
            boxSize={[9, 9, 10, 10]}
            borderRadius="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginLeft="auto"
            _hover={{
              bg: '#F9DD7D',
            }}
            transition="0.5s"
            cursor="pointer"
            onClick={toggleAudio}
          >
            <SoundDisabled boxSize={[4, 4, 5, 5]} />
          </Box>
        )}

        <Box
          bg="#FDC506"
          aria-label="To Spread Joy"
          boxSize={[9, 9, 10, 10]}
          borderRadius="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginLeft="auto"
          _hover={{
            bg: '#F9DD7D',
          }}
          transition="0.5s"
          cursor="pointer"
          onClick={() => openSpread()}
        >
          <Share boxSize={[5, 5, 6, 6]} />
        </Box>

        {activeLocale === 'ar' ? (
          <Box
            bg="#FDC506"
            aria-label="To English"
            boxSize={[9, 9, 10, 10]}
            borderRadius="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginLeft="auto"
            _hover={{
              bg: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => setLocale('en')}
            cursor="pointer"
          >
            <ToEng boxSize={[7, 7, 8, 8]} />
          </Box>
        ) : (
          <ToArabic
            marginLeft="auto"
            boxSize={[9, 9, 10, 10]}
            cursor="pointer"
            borderRadius="100%"
            fill="#FDC506"
            _hover={{
              fill: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => setLocale('ar')}
          />
        )}

        {activeScene === 'ramadan_0' ? (
          <Box
            bg="#FDC506"
            aria-label="To Terrace"
            boxSize={[9, 9, 10, 10]}
            borderRadius="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginLeft="auto"
            _hover={{
              bg: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => {
              setActiveScene('ramadan_17');
              window.GotoScene && window.GotoScene('ramadan_17');
            }}
            cursor="pointer"
          >
            <Up boxSize={[5, 5, 6, 6]} />
          </Box>
        ) : (
          <Box
            bg="#FDC506"
            aria-label="To Indoor"
            boxSize={[9, 9, 10, 10]}
            borderRadius="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginLeft="auto"
            _hover={{
              bg: '#F9DD7D',
            }}
            transition="0.5s"
            onClick={() => {
              setActiveScene('ramadan_0');
              window.GotoScene && window.GotoScene('ramadan_0');
            }}
            cursor="pointer"
          >
            <Down boxSize={[5, 5, 6, 6]} />
          </Box>
        )}
      </Box>

      {/* Created By Emperia Link */}
      <Link href="https://emperiavr.com/" target="_blank">
        <Box position="fixed" bottom={['15px', '20px', '25px']} right={['15px', '20px', '25px']} cursor="pointer">
          <Image
            loading="lazy"
            src={activeLocale === 'ar' ? CreatedByEmperiaAR : CreatedByEmperia}
            width={['150px', '150px', '200px', '200px', '200px', '200px']}
          />
        </Box>
      </Link>
    </Box>
  );
};

export default Overlay;
